import { ArrowLeftIcon } from '@persona-id/design-tokens/icons';
import styled from 'styled-components';

import { View } from 'dashboard/components/PlanUpgradeFlow';
import FormBillingInfo from 'dashboard/forms/FormBillingInfo';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';

interface PaymentMethodProps {
  handleSubmitBillingInfo: (stripeId: string) => Promise<void>;
  showMessage: (message: string) => void;
  handleNavToPreviousView: (currentView: View) => void;
  onClose: () => void;
}

const PaymentMethod = ({
  handleSubmitBillingInfo,
  showMessage,
  handleNavToPreviousView,
  onClose,
}: PaymentMethodProps) => {
  return (
    <StyledModalContainer>
      <ModalHeader
        prefixIcon={<ArrowLeftIcon size={20} />}
        onPrefixIconClick={() => handleNavToPreviousView(View.PaymentMethod)}
        onClose={onClose}
      >
        Update billing information
      </ModalHeader>
      <ModalBody>
        <Paragraph color='primary' size='lg'>
          To begin our business review process, first submit your payment details (don&apos;t worry
          - you won&apos;t be charged right away). Then, we&apos;ll walk you through the business
          information we need to collect.
        </Paragraph>
        <Spacer height={3} />
        <FormBillingInfo
          handleSubmit={handleSubmitBillingInfo}
          handleClose={() => handleNavToPreviousView(View.PaymentMethod)}
          showMessage={showMessage}
        />
      </ModalBody>
    </StyledModalContainer>
  );
};

const StyledModalContainer = styled(ModalContainer)`
  min-width: 700px;
`;

export default PaymentMethod;
